
export const init_start = (state) => {
  state.init_status = false
  state.error = false
}
export const init_done = (state) => state.init_status = true
export const set_error = (state) => state.error = true
export const clear_error = (state) => state.error = false

export const set_department_id = (state, id) => state.department_id = id
export const set_department = (state, data) => state.department = data
export const set_consultants = (state, data) => state.consultants = data
export const set_topics = (state, data) => state.topics = data
export const set_subjects = (state, data) => state.subjects = data

// export const set_blocks = (state, data) => state.blocks = data.map
export const set_blocks = (state, data) => state.blocks = data.map( d => {
  var o = Object.assign( {}, d )
  d.display = false
  return d
})

export const STORE_CONTENT = (state, data) => state.content = data

export const INIT_QUIZ_STATUSES = (state, data) => state.quiz_blocks_status = data

export const APPEND_QUIZ_BLOCKS_STATUS = (state, data) => state.quiz_blocks_status.push(data)
export const UPDATE_QUIZ_STATUS = (state, data ) => {
  // console.log( 'UPDATE_QUIZ_STATUS', data )
  let q = state.quiz_blocks_status.find( q => q.id == data.id )
  if( q ) {
    q.max_points = data.max_points
    q.reached_points = data.reached_points
    q.done = data.done
    q.answers = data.answers
  }
}

export const set_current_department_id = (state, id) => {
  state.current_department_id = id
  state.current_topic_id = null
  state.current_subject_id = null
}
export const set_current_topic_id = (state, id) => {
  state.current_topic_id = id
  state.current_subject_id = null
}
export const set_current_subject_id = (state, id) => state.current_subject_id = id
